/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetTenantRequest = {
  /**
   * The ID of the tenant. Required when using AdminApiKey authentication.
   */
  tenantId: string;
};

/** @internal */
export const GetTenantRequest$inboundSchema: z.ZodType<
  GetTenantRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  tenant_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "tenant_id": "tenantId",
  });
});
/** @internal */
export type GetTenantRequest$Outbound = {
  tenant_id: string;
};

/** @internal */
export const GetTenantRequest$outboundSchema: z.ZodType<
  GetTenantRequest$Outbound,
  z.ZodTypeDef,
  GetTenantRequest
> = z.object({
  tenantId: z.string(),
}).transform((v) => {
  return remap$(v, {
    tenantId: "tenant_id",
  });
});

export function getTenantRequestToJSON(
  getTenantRequest: GetTenantRequest,
): string {
  return JSON.stringify(
    GetTenantRequest$outboundSchema.parse(getTenantRequest),
  );
}
export function getTenantRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetTenantRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetTenantRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetTenantRequest' from JSON`,
  );
}
